export default __webpack_public_path__ + "static/media/item-quantity.9f81a711.png";